<template>
    <div class="ask-offer">
        <div class="container">
            <div class="ask-offer__wrapper">
                <div class="ask-offer__wrapper__description">
                    <h3>{{ $t('askOfferTitle') }}</h3>
                    <p>{{ $t('askOfferDescription') }}</p>
                </div>
                <div class="ask-offer__wrapper__form">
                    <form @submit.prevent="submitHandler">
                        <div class="ask-offer__wrapper__form-group">
                            <label for="phoneNumber">{{ $t('askOfferFormInputPhoneLabel') }}</label>
                            <MyInput
                                class="ask-us__wrapper__form__group__input"
                                v-model="form.phoneNumber"
                                @get-number-count="getNumberCount"
                                type="tel"
                                theme="gray"
                                placeholder=""
                                :class="{
                                    'ask-offer__wrapper__form-group__input': true,
                                    '--invalid': $v.form.phoneNumber.$invalid && this.form.getSubmited
                                }"
                            />
                        </div>
                        <button
                            type="submit"
                            :class="{
                                'ask-offer__wrapper__form-group__button': true,
                                disabled: $v.form.phoneNumber.$invalid && this.form.getSubmited
                            }"
                            :disabled="$v.form.phoneNumber.$invalid"
                        >
                            {{ $t('askOfferFormActionCallback') }}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { minLength, required } from 'vuelidate/lib/validators';
import eventBus from '~/plugins/event-bus';
import connectTelInput from '~/mixins/connect-tel-input';
import MyInput from '@/themes/novaporta/components/ui/MyInput';
import phoneCount from '~/mixins/phone-validation-count';

const initialFormState = {
    phoneNumber: '',
    getSubmited: false
};
export default {
    mixins: [phoneCount, connectTelInput],
    name: 'AskOffer',
    data() {
        return {
            form: { ...initialFormState }
        };
    },
    components: {
        MyInput
    },
    validations() {
        return {
            form: {
                phoneNumber: {
                    required,
                    minLength: minLength(this?.phoneMinlength || 8)
                }
            }
        };
    },
    methods: {
        resetForm() {
            this.form = { ...initialFormState };
            this.$v.$reset();
        },
        sendSuccessNotification() {
            eventBus.$emit('show-toast', {
                message: this.$t('askOfferFormMessageRequestSuccess'),
                type: 'success'
            });
        },
        sendErrorNotification() {
            eventBus.$emit('show-toast', {
                message: this.$t('askOfferFormMessageRequestFailed'),
                type: 'failure'
            });
        },
        async submitHandler() {
            this.form.getSubmited = true;
            try {
                this.$v.form.$touch();
                if (this.$v.form.$invalid === false) {
                    await this.$api.home.postBookConsultation({
                        name: 'name', // name is required
                        phone: this.form.phoneNumber,
                        request_purpose: 'order_call'
                    });
                    this.sendSuccessNotification();
                    this.resetForm();
                }
            } catch (e) {
                this.sendErrorNotification();
                throw new Error(e);
            }
        }
    }
};
</script>
<style scoped lang="scss">
@import './styles';
</style>
